<section
  class="hero is-fullheight has-navbar-fixed-top"
  style="margin-top: -52px;"
>
  <div class="hero-body">
    <div class="container">
      <h1 class="title">{{ title }}</h1>
      <h2 class="subtitle">{{ text }}</h2>
    </div>
  </div>
</section>
